export interface AgentInfoResponse {
  success: boolean;
  voice_agent_enabled: boolean;
  has_elevenlabs_agent: boolean;
  elevenlabs_agent_id?: string;
  whatsapp_number?: string;
  agent_name?: string;
  avatar?: string;
  error_message?: string;
}

export async function getAgentInfo(
  agentPublicId: string,
  apiUrl: string
): Promise<AgentInfoResponse> {
  const url = `${apiUrl}/api/v1/agent/public/${agentPublicId}/info`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => {
      return { response_message: 'Network error occurred' };
    });
    throw new Error(error.response_message || 'Unable to load agent');
  }

  const result = await response.json();

  if (!result.success) {
    throw new Error(result.response_message || 'Unable to load agent configuration');
  }

  const data = result.agent_info;
  if (!data) {
    throw new Error('Agent not found');
  }

  return {
    success: true,
    voice_agent_enabled: data.voiceAgentEnabled || false,
    has_elevenlabs_agent: Boolean(data.elevenlabsAgentId),
    elevenlabs_agent_id: data.elevenlabsAgentId,
    whatsapp_number: data.whatsappNumber || undefined,
    agent_name: data.name,
    avatar: data.avatar ? new URL(data.avatar, apiUrl).href : undefined,
    error_message: undefined,
  } as AgentInfoResponse;
}
